import immutableStore from 'alt-utils/lib/ImmutableUtil';
import alt from 'components/Dispatcher';
import SearchFieldActions from 'actions/triggers/SearchFieldActions';
import {List} from 'immutable';

@immutableStore
class SearchFieldStore {
  constructor() {
    this.state = {
      searchFields: List(),
      searchFieldsLoading: true,
      searchFieldsLoaded: false,
    };

    this.bindActions(SearchFieldActions);
  }
  fetchSearchFields() {
    this.setState({
      ...this.state,
      searchFields: List(),
      searchFieldsLoading: true,
      searchFieldsLoaded: false,
    });
  }

  fetchSearchFieldsSuccess(searchFields) {
    this.setState({
      ...this.state,
      searchFields: List(searchFields),
      searchFieldsLoading: false,
      searchFieldsLoaded: true,
    });
  }

  fetchSearchFieldsError(response) {
    this.setState({
      ...this.state,
      searchFields: List(),
      searchFieldsLoading: false,
      searchFieldsLoaded: false,
    });

    console.warn(response);
  }
}

export default alt.createStore(SearchFieldStore, 'SearchFieldStore');
